import { GridContainer, CustomContainer, AppText } from "src/style"
import Lottie from "lottie-react";
import notFoundGif from "src/assets/gif/notFound.json";

export const NotFound = () => {
    return (
        <GridContainer 
            height="100" hUnit="%" padding='2.5'
            style={{overflow: 'hidden'}}
        >
            <CustomContainer width="auto" sizeUnit="">
                <Lottie animationData={notFoundGif} loop={true} />
            </CustomContainer>
        </GridContainer>
    )
}